export default "__VITE_ASSET__BuvRtvs6__"